/**
 * Coeur mobile homepage: large centered wordmark shrinks into the header on scroll.
 */
(function () {
  const splash = document.querySelector('[data-coeur-logo-splash]');
  if (!splash) return;
  if (window.innerWidth >= 750) return;

  const headerLogo = document.querySelector('.header--coeur .header__heading-logo-wrapper');

  const SHRINK_DISTANCE = 200;
  const MIN_SCALE = 0.60;

  const startY = window.innerHeight * 0.38;
  const logoRect = headerLogo ? headerLogo.getBoundingClientRect() : null;
  const targetY = logoRect ? logoRect.top + logoRect.height / 2 : startY * 0.1;
  const totalLift = startY - targetY;

  console.log('DEBUG:', { headerLogo, startY, logoRect, targetY, totalLift });

  let ticking = false;

  function update() {
    ticking = false;
    const y = window.scrollY || window.pageYOffset;
    const progress = Math.min(Math.max(y / SHRINK_DISTANCE, 0), 1);

    const scale = 1 - progress * (1 - MIN_SCALE);
    const liftPx = progress * totalLift;

    console.log('SCROLL:', { y, progress, liftPx });

    splash.style.transform = `translate(-50%, calc(-50% - ${liftPx}px)) scale(${scale})`;
    splash.classList.toggle('coeur-mobile-logo-splash--done', progress >= 1);
  }

  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(update);
      ticking = true;
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', () => {
    if (window.innerWidth >= 750) {
      splash.style.display = 'none';
    }
  });

  update();
})();